import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Service.css';

const Service: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location.hash]);

  const modules = [
    {
      id: 'pick',
      name: 'PICK',
      description: '고객사 픽업 서비스',
      summary: '고객사 픽업',
      customerBenefit: '리드타임 단축, 탄력 수거',
      coreFunctions: [
        '고객사·지정지 픽업',
        '수도권 당일 픽업 및 긴급 대응',
        '정기/비정기 스케줄 운영',
        '차량 타입 선택 가능(다마스~1톤~5톤)',
        '천일 내국운송 네트워크 연계 배차'
      ],
      customerValues: [
        '출고 지연 리스크 감소',
        '상차·이동 이슈 단일 창구 해결',
        '물량 변동에도 안정적인 운송 대응'
      ],
      image: '/images/core/core_pick.png'
    },
    {
      id: 'pack',
      name: 'PACK',
      description: '상품화/소작업 서비스',
      summary: '상품화/라벨링/재포장',
      customerBenefit: '오류 감소, 채널별 규격 맞춤',
      coreFunctions: [
        '라벨링(식품·생활용품·KC·유통규격)',
        '재포장(불량박스 교체, 분할포장)',
        '세트 구성(번들·기획·프로모션)',
        '패키지 교체 / PB 패키징',
        '수입요건·유통사 스펙 기반 작업 기준 적용'
      ],
      customerValues: [
        '유통사 반려·재작업 최소화',
        '수입~납품 규격 불일치 리스크 감소',
        '대량·반복 작업 안정적 대응'
      ],
      image: '/images/core/core_pack.png'
    },
    {
      id: 'transfer',
      name: 'TRANSFER',
      description: '코스트코 평택디포',
      summary: '평택권 유통센터·디포 연계 환적',
      customerBenefit: '편리한 예약기능',
      coreFunctions: [
        '유통센터/디포 도착 후 재배차·환적',
        '팔레타이징 / 디팔레타이징',
        '출고 스케줄 기반 환적 운영',
        '유통센터·3PL·공장 간 다회 운송 대응',
        '천일 코스트코 857(DRY) 납품대행 운영 기준 적용'
      ],
      customerValues: [
        '중간 허브 역할 수행',
        '납품 동선 단순화',
        '예약·납품 실패 리스크 감소',
        '긴급·대량 물량 대응력 확보'
      ],
      image: '/images/core/core_transfer.png'
    },
    {
      id: 'store',
      name: 'STORE',
      description: '보관(Warehousing)',
      summary: '보관/WMS',
      customerBenefit: '재고 정확도, 비용 안정',
      coreFunctions: [
        '상온 / 냉장 / 냉동 보관',
        '중·단기 및 장기 보관',
        'WMS 기반 재고·LOT·유통기한 관리',
        '반품 보관 및 재정리',
        '보세창고·내수창고 연계 운영 가능'
      ],
      customerValues: [
        '재고 정확도 향상',
        '유통기한 관리 리스크 최소화',
        '보세→내수 전환 시 추가 이동·작업 최소화'
      ],
      image: '/images/core/core_store.png'
    },
    {
      id: 'ship',
      name: 'SHIP',
      description: '배송/출고 서비스',
      summary: '배송/출고',
      customerBenefit: '전국출고, 유통센터 대응',
      coreFunctions: [
        '전국 택배·화물·전용차 배송',
        'B2B/B2C 출고 지원',
        '유통센터 납품 스펙 대응',
        '반품 회수 프로세스 운영',
        '납품 POD 및 증빙 패키지 확보'
      ],
      customerValues: [
        '납품 클레임 감소',
        '정시 출고율 향상(운영 KPI 기준)',
        '월 정산·증빙 관리 용이'
      ],
      image: '/images/core/core_ship.png'
    },
    {
      id: 'import',
      name: 'IMPORT 3PL',
      description: '수입화물 물류대행',
      summary: '수입–보세–내수 연계 통합 물류',
      customerBenefit: '수입~유통 One-Stop',
      coreFunctions: [
        '수입화물 입고 · 통관 지원 · 보세창고 보관 · 출고등, 통합 운영',
        '수입요건 컨설팅 및 세관장 요건 행정업무 대행',
        '한글라벨·리패킹 등 상품화 작업',
        '유통기한·LOT 기준 재고/출고 관리',
        '대형 유통사 기준 리포트 제공'
      ],
      customerValues: [
        '수입~국내 유통까지 One-Stop 아웃소싱',
        '내부 인력·운영비 절감',
        '수입요건 미비로 인한 통관·납품 지연 리스크 최소화'
      ],
      image: '/images/core/core_import.png'
    }
  ];

  const strengths = [
    { number: '01', title: '수입요건·행정 전문성', description: '수입요건·행정 전문성 기반 물류 설계' },
    { number: '02', title: '보세·내수 물류 통합', description: '보세–내수–납품 단절 없는 운영 구조' },
    { number: '03', title: '대형 유통사 대응 경험', description: '코스트코 및 대형 유통사 납품대행 경험 기반 운영' },
    { number: '04', title: '책임 운영', description: '상품화·검수·납품 증빙까지 포함한 책임 운영' },
    { number: '05', title: '인력 대체 효과', description: '밴더사 내부 물류·운영 인력 대체 효과' }
  ];

  const synergies = [
    '물류·납품 담당 인력 최소화',
    '수입요건·라벨·납품 규격을 사전 단계에서 일괄 관리',
    '납품 실패/반려 시 증빙 기반 클레임 대응 가능',
    '수입 → 보세 → 상품화 → 납품까지 한 파트너로 고정 운영',
    '물량 증가 시에도 운영 구조 변경 없이 확장 가능'
  ];

  return (
    <div className="service-page">
      {/* =================================================================
          Hero — editorial
          ================================================================= */}
      <section
        className="service-hero"
        style={{ backgroundImage: "url(https://gallery.chunilkor.co.kr/ps/service-hero.jpg)" }}
      >
        <div className="container">
          <div className="hero-eyebrow">
            <span>01 / Services</span>
            <span className="hero-eyebrow-divider" />
            <span>2PT2SI · 6 Core Modules</span>
          </div>
          <h1 className="hero-title">천일 서비스</h1>
          <p className="hero-lede">
            6대 모듈 기반 조합형 물류 서비스로, 밴더사의 납품·운영 부담을 구조적으로 줄입니다.
          </p>
          <div className="hero-cta">
            <Link to="/contact" className="btn-editorial-light">
              견적 요청하기
              <span aria-hidden className="arrow">→</span>
            </Link>
          </div>
        </div>
      </section>

      {/* =================================================================
          Section 02 — ONE STOP SYSTEM infographic (6 modules overview)
          ================================================================= */}
      <section className="service-section service-intro-section">
        <div className="container">
          <div className="section-header-split">
            <div className="section-header-left">
              <div className="eyebrow">02 / Overview</div>
              <h2 className="section-title">ONE STOP SYSTEM</h2>
            </div>
            <div className="section-header-right">
              <p className="section-lede">
                천일국제물류의 수입·보세·내수 물류 역량을 6대 코어 모듈로 통합한 운영형 물류 솔루션.
              </p>
              <p className="section-meta">
                <span className="meta-label">PICK</span>
                <span className="meta-divider">→</span>
                <span className="meta-label">PACK</span>
                <span className="meta-divider">→</span>
                <span className="meta-label">TRANSFER</span>
                <span className="meta-divider">→</span>
                <span className="meta-label">STORE</span>
                <span className="meta-divider">→</span>
                <span className="meta-label">SHIP</span>
                <span className="meta-divider">+</span>
                <span className="meta-label amber">IMPORT 3PL</span>
              </p>
            </div>
          </div>

          <div className="modules-infographic">
            {modules.map((module, index) => (
              <a href={`#${module.id}`} key={module.id} className="module-infographic-item">
                <div className="module-infographic-number">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div className="module-icon-wrapper">
                  <img src={module.image} alt={module.name} className="module-icon-image" loading="lazy" />
                </div>
                <div className="module-infographic-label">
                  <span className="module-label-english">{module.name}</span>
                  <span className="module-label-korean">{module.summary}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* =================================================================
          Section 03 — 6 core modules detail (editorial alternating)
          ================================================================= */}
      <section className="service-section modules-section">
        <div className="container">
          <div className="section-header-split">
            <div className="section-header-left">
              <div className="eyebrow">03 / Modules</div>
              <h2 className="section-title">6대 코어 모듈</h2>
            </div>
            <div className="section-header-right">
              <p className="section-lede">
                고객의 물류 요구사항에 맞춰 자유롭게 조합 가능한 모듈형 서비스. 각 모듈은 독립 운영되며, 필요한 단계만 선택할 수 있습니다.
              </p>
            </div>
          </div>

          <div className="modules-detail-list">
            {modules.map((module, index) => (
              <article key={module.id} id={module.id} className="module-card">
                <header className="module-card-header">
                  <span className="module-card-index">
                    A.{String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="module-card-divider" />
                  <span className="module-card-code">{module.name}</span>
                </header>

                <div className="module-card-body">
                  <div className="module-card-figure">
                    <img src={module.image} alt={module.name} className="module-card-image" loading="lazy" />
                  </div>

                  <div className="module-card-text">
                    <h3 className="module-card-title">{module.summary}</h3>
                    <p className="module-card-description">{module.description}</p>

                    <div className="module-card-benefit">
                      <span className="module-card-benefit-label">Customer Benefit</span>
                      <span className="module-card-benefit-value">{module.customerBenefit}</span>
                    </div>
                  </div>
                </div>

                <div className="module-card-lists">
                  <div className="module-card-list-group">
                    <div className="eyebrow">Core Functions</div>
                    <ul className="module-card-list">
                      {module.coreFunctions.map((func, idx) => (
                        <li key={idx}>
                          <span className="list-index">{String(idx + 1).padStart(2, '0')}</span>
                          <span className="list-text">{func}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="module-card-list-group">
                    <div className="eyebrow amber">Customer Value</div>
                    <ul className="module-card-list">
                      {module.customerValues.map((value, idx) => (
                        <li key={idx}>
                          <span className="list-index amber">{String(idx + 1).padStart(2, '0')}</span>
                          <span className="list-text">{value}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =================================================================
          Section 04 — Strengths (numbered editorial rows)
          ================================================================= */}
      <section className="service-section strengths-section">
        <div className="container">
          <div className="section-header-split">
            <div className="section-header-left">
              <div className="eyebrow">04 / Strengths</div>
              <h2 className="section-title">서비스 강점</h2>
            </div>
            <div className="section-header-right">
              <p className="section-lede">
                단순 3PL이 아닌, 밴더사의 수입·납품 전 과정을 책임지는 운영 파트너로서의 차별점.
              </p>
            </div>
          </div>

          <ol className="strengths-list">
            {strengths.map((item) => (
              <li key={item.number} className="strength-row">
                <span className="strength-number">{item.number}</span>
                <div className="strength-content">
                  <h3 className="strength-title">{item.title}</h3>
                  <p className="strength-description">{item.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* =================================================================
          Section 05 — Vendor synergy (clean editorial checklist)
          ================================================================= */}
      <section className="service-section vendor-synergy-section">
        <div className="container">
          <div className="section-header-split">
            <div className="section-header-left">
              <div className="eyebrow">05 / Synergy</div>
              <h2 className="section-title">밴더사 시너지</h2>
            </div>
            <div className="section-header-right">
              <p className="section-lede">
                밴더사가 천일과 협업했을 때 실질적으로 얻는 운영·비용·리스크 측면의 개선.
              </p>
            </div>
          </div>

          <ul className="synergy-list">
            {synergies.map((text, idx) => (
              <li key={idx} className="synergy-item">
                <span className="synergy-index">{String(idx + 1).padStart(2, '0')}</span>
                <p className="synergy-text">{text}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* =================================================================
          Section 06 — Final CTA (navy editorial)
          ================================================================= */}
      <section className="service-cta-section">
        <div className="container">
          <div className="cta-grid">
            <div className="cta-left">
              <div className="eyebrow light">06 / Contact</div>
              <h2 className="cta-title">
                천일국제물류는 <span className="accent-amber">운송 회사가 아니라,</span><br />
                밴더사의 수입·납품 운영을 <span className="accent-white">대신 설계하고 책임지는 파트너</span>입니다.
              </h2>
            </div>
            <div className="cta-right">
              <Link to="/contact" className="btn-editorial-light">
                견적 요청하기
                <span aria-hidden className="arrow">→</span>
              </Link>
              <p className="cta-note">상담 시간: 평일 10:00 – 18:00 (점심 12:00 – 13:00)</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service;
